import { styled } from '../../Utilities';
import { ChoiceGroupBase } from './ChoiceGroup.base';
import { getStyles } from './ChoiceGroup.styles';
export var ChoiceGroup = styled(ChoiceGroupBase, getStyles, undefined, {
  scope: 'ChoiceGroup'
});